export var redirectUrlCookieKey = "redirectUrl";
